import { useDebounce } from "use-debounce";

/** Shared delay for URL-backed / server-paginated search inputs. */
const SEARCH_DEBOUNCE_MS = 300;

/** Debounce a value before it hits the network. Prefer over hand-rolled timers. */
export function useDebouncedValue<T>(
  value: T,
  ms: number = SEARCH_DEBOUNCE_MS,
): T {
  const [debounced] = useDebounce(value, ms);
  return debounced;
}
